import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {removeLicenses} from "../../../../../api/asset/LicenseService";
import Search from "../../../../../components/search/Search";
import {handleActiveToast} from "../../../../../components/sonner/ToastBasic";
import {LICENSE_LIST_HEADER} from "../../../../../components/table/header/Headers";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../../components/commonmethod/CommonMethod";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../components/pageTabs/pageTabsStorage";
import {useExcelDownloadClick} from "../../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../../components/js-grid/JsGridExcelGridOpenButton";

function LicenseListListType({checked, data, date, pageInfo, dataHook}) {
    const navigate = useNavigate();
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: LICENSE_LIST_HEADER, exclude: []});

    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, LICENSE_LIST_HEADER, setHeader, [], () => {}, () => {}, 'license');
        });
    }, []);

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "라이선스 상세"),
            url: `/license/${id}`,
        });
    };

    const deleteLicense = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 라이선스를 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        try {
            const ids = rows.map((row) => row.id).filter((id) => id != null);
            const response = await removeLicenses({ids});
            if (response.status === 200) {
                handleActiveToast({message: "라이선스가 삭제되었습니다."});
                checked?.setChecked?.([]);
                refresh();
            } else {
                handleActiveToast({message: "삭제할 권한이 없습니다."});
            }
        } catch (error) {
            if (error.response?.status === 403) {
                handleActiveToast({message: "삭제할 권한이 없습니다."});
            } else {
                alert("서버와 연결할 수 없습니다. 잠시 후 다시 시도하세요.");
                throw new Error("서버 연결 실패");
            }
        }
    };

    const licenseJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search entity={'License'} refresh={refresh} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} searchBar={{placeHolder: '명칭'}} size date={searchDate} />

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={licenseJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {license: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'license')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="License" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deleteLicense}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        disabled={ctx.disabled}
                                        onClick={() => void ctx.transferSelected()}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/license/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}
export default LicenseListListType;
